<template>
  <main class="iletisim-page">
    <section class="intro">
      <div class="intro-inner">
        <div class="intro-copy">
          <h1>OCN Gübre'ye hızlıca ulaşın</h1>
          <p class="lead">
            Samsun'daki merkez ofisimiz ve depolarımızla üretici, bayi ve iş ortaklarımıza destek veriyoruz.
            Telefon, e-posta ya da yerinde ziyaret için tüm bilgiler aşağıda.
          </p>
        </div>
      </div>
    </section>

    <section class="cards">
      <div class="cards-inner">
        <div class="card">
          <p class="eyebrow small">Merkez Ofis</p>
          <h3>Kirazlık Mahallesi, Örnek Sanayi Sitesi</h3>
          <p class="card-text">
            Ziyaret, toplantı veya belge paylaşımınız için randevu alabilirsiniz. Merkez ofisimizde planlama ve operasyon
            ekipleri sizi bekliyor.
          </p>
        </div>
        <div class="card">
          <p class="eyebrow small">Depolar</p>
          <h3>Dağıtım noktalarımız</h3>
          <ul class="depo-list">
            <li v-for="(depo, idx) in depolar" :key="idx">Depo {{ idx + 1 }} - {{ depo }}</li>
          </ul>
        </div>
        <div class="card">
          <p class="eyebrow small">Destek Kanallarımız</p>
          <h3>Sizin için buradayız</h3>
          <p class="card-text">
            Sipariş bilgisi, sevkiyat ve teknik destek için telefon ve e-posta hatlarımızdan ulaşabilirsiniz.
          </p>
          <div class="info">
            <div class="info-row">
              <span class="label">Telefon</span>
              <span class="value">{{ contact.Telefon }}</span>
            </div>
            <div class="info-row">
              <span class="label">E-Posta</span>
              <span class="value">{{ contact['E-Mail'] }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="map-section">
      <div class="map-inner">
        <div class="map-copy">
          <p class="eyebrow">Konum</p>
          <h2>Yol tarifi alın</h2>
          <p class="section-lead">
            Örnek Sanayi Sitesi içindeyiz. Haritadan yol tarifi alabilir veya sahaya çıkmadan önce bizi arayabilirsiniz.
          </p>
          <a
            class="btn ghost"
            href="https://maps.google.com/?q=41.24720658562334,36.40790244461153"
            target="_blank"
            rel="noopener"
          >
            Google Maps
          </a>
        </div>
        <div class="map-frame">
          <div id="map"></div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import contactInfo from '@/assets/contact_info.json';

export default {
  name: 'AppIletisim',
  data() {
    return {
      contact: {},
      depolar: []
    };
  },
  mounted() {
    this.contact = contactInfo.contact[0];
    this.depolar = Object.keys(this.contact)
      .filter(key => key.toLowerCase().includes('depo'))
      .map(key => this.contact[key]);

    if (typeof google !== 'undefined') {
      this.initMap();
    } else {
      window.initMap = this.initMap;
    }
  },
  methods: {
    initMap() {
      const location = { lat: 41.24720658562334, lng: 36.40790244461153 };

      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(document.getElementById('map'), {
        zoom: 18,
        center: location,
        styles: [
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
          }
        ]
      });

      // eslint-disable-next-line no-undef
      new google.maps.Marker({
        position: location,
        map,
        title: 'OCN Gübre'
      });
    }
  }
};
</script>

<style scoped>
.iletisim-page {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: 100vh;
  display: grid;
  gap: 28px;
  padding: 28px 0 56px;
}

.intro,
.cards,
.map-section {
  width: var(--page-width);
  margin: 0 auto;
  box-sizing: border-box;
}

.intro-inner {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  align-items: stretch;
  justify-items: center;
}

.intro-copy {
  display: grid;
  gap: 12px;
  color: #0f172a;
  text-align: center;
  justify-items: center;
  max-width: 780px;
}

.intro-copy .eyebrow {
  justify-self: start;
  text-align: left;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 800;
  color: #0f766e;
}

.eyebrow::before {
  content: '';
  width: 18px;
  height: 2px;
  background: #0f766e;
  border-radius: 999px;
}

.eyebrow.small {
  font-size: 11px;
}

h1 {
  margin: 0;
  font-size: 30px;
}

.lead {
  margin: 0;
  color: #1f2937;
  line-height: 1.6;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.btn {
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 12px 16px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}

.btn.primary {
  background: #0f172a;
  color: #f8fafc;
  border-color: #0f172a;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);
}

.btn.primary:hover {
  transform: translateY(-2px);
  background: #0b1221;
}

.btn.ghost {
  background: rgba(255, 255, 255, 0.9);
  color: #0f172a;
  border-color: #cbd5e1;
}

.btn.ghost:hover {
  transform: translateY(-2px);
  border-color: #0f766e;
  color: #0f766e;
  background: #ecfdf3;
}

.intro-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px;
  display: grid;
  gap: 12px;
}

.logo-wrap {
  display: flex;
  justify-content: center;
}

.logo {
  height: 42px;
  width: auto;
}

.info {
  display: grid;
  gap: 10px;
}

.info-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 8px;
  align-items: baseline;
}

.label {
  font-weight: 700;
  color: #0f172a;
}

.value {
  color: #334155;
  line-height: 1.5;
}

.cards-inner {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
}

.card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  display: grid;
  gap: 8px;
  color: #0f172a;
}

.card h3 {
  margin: 0;
  font-size: 18px;
}

.card-text {
  margin: 0;
  color: #334155;
  line-height: 1.55;
}

.depo-list {
  margin: 0;
  padding-left: 16px;
  color: #334155;
  line-height: 1.5;
}

.map-inner {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 20px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 16px;
  align-items: stretch;
}

.map-copy {
  display: grid;
  gap: 10px;
  color: #0f172a;
}

.map-copy h2 {
  margin: 0;
  font-size: 24px;
}

.section-lead {
  margin: 0;
  color: #1f2937;
  line-height: 1.6;
}

.map-frame {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  min-height: 320px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

#map {
  width: 100%;
  height: 100%;
}

.map-section .btn.ghost {
  justify-content: center;
  padding: 10px 14px;
  line-height: 1.2;
  min-height: 44px;
  white-space: nowrap;
}

@media (max-width: 960px) {
  .intro-inner,
  .map-inner {
    grid-template-columns: 1fr;
  }

  .info-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .iletisim-page {
    padding: 18px 0 44px;
    gap: 22px;
  }

  .intro,
  .cards,
  .map-section {
    width: calc(100% - 24px);
  }

  .intro-inner,
  .map-inner {
    padding: 16px;
  }

  .actions {
    flex-direction: column;
  }
}
</style>
